/**
 * ProcurementItemService
 * Service for ProcurementItem entity operations
 * Route: api/procurementitem
 * Controller: ProcurementItemController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProcurementItemService
 * Handles procurement item CRUD operations
 * Maps to /api/procurementitem endpoint
 */
export class ProcurementItemService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProcurementItemService.DEFAULT_SERVICE_PATH,
            basePath: ProcurementItemService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get procurement items by category
     */
    async getByCategory(categoryId) {
        const response = await this.http.get(this.buildUrl(`category/${categoryId}`));
        return response.data;
    }
    /**
     * Get active procurement items
     */
    async getActive() {
        const response = await this.http.get(this.buildUrl('active'));
        return response.data;
    }
    /**
     * Search procurement items by query
     */
    async search(query) {
        const response = await this.http.get(this.buildUrl(`search?query=${encodeURIComponent(query)}`));
        return response.data;
    }
}
ProcurementItemService.DEFAULT_SERVICE_PATH = 'procurements';
ProcurementItemService.BASE_PATH = 'api/procurementitem';
//# sourceMappingURL=ProcurementItemService.js.map